import { initProps } from '@/utils/props-formatter'
import { getDatasource } from "@/datasource";
import { ElNotification, ElMessageBox } from 'element-plus';
export default {
    name: "CommandClose",
    execute: (action, context) => {
        const config = JSON.parse(JSON.stringify(action))
        //
        initProps(config, context, context)
        // console.log(config)
        /***
         * {
                url: 'c/Department',
                param: '${selected}',
                method:'delete',
                success: '数据已删除!',
                confirm: '是否删除数据'
            }
         */
        const d = getDatasource('default')?.create(config.params, config.params.data, {}) //数据源定义
        // console.log(d)
        const exe = () => {
            d.value.run().then(() => {
                action.params.success && ElNotification.error({
                    title: '操作成功',
                    message: action.params.success
                });
                context.load()
            }).catch(() => {
                action.params.error && ElNotification.error({
                    title: '操作失败',
                    message: action.params.error
                });
                context.load()
            });
        }
        action.params.confirm ? ElMessageBox.confirm(
            action.params.confirm,
            '警告',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        ).then(() => {
            exe()
        }) : exe()

    }
}